<template>
  <a-modal :open="formOpen" @cancel="setFormClosed">
    <template #title>
      <div class="modal-header">Уведомить пользователей {{ type === 'test' ? 'об оценке' : 'о развитии'}}</div>
      <a-divider style="margin: 16px 0" />
    </template>
    <a-select
        v-model:value="notificationForm.notificationGroups"
        mode="multiple"
        :placeholder="labels[type].placeholderMultiselect"
        style="width: 100%;"
        :not-found-content="'Нет данных'"
    >
      <a-select-option v-for="item in availableTags" :key="item.id" :value="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>

    <div class="notification-button-wrapper">
      <div class="notification-status-header">Уведомить в статусе</div>
      <a-checkbox v-model:checked="notificationForm.notifyNew">Не начали</a-checkbox>
      <a-checkbox v-model:checked="notificationForm.notifyInProgress">В процессе</a-checkbox>
    </div>

    <template #footer>
      <div class="download-button-wrapper">
        <a-button key="back" class="secondary-button" @click="setFormClosed">Отменить</a-button>
        <a-button key="submit" type="primary" class="primary-button" :loading="notificationIsSending" @click="sendNotifications">Отправить</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
  import {ref} from "vue";
  import {reactive} from "@vue/runtime-core";
  import {useStore} from "vuex";
  import {message} from "ant-design-vue";

  export default {
    props: {
      type: String,
      formOpen: Boolean,
      labels: Object,
      availableTags: { type: Array, default: () => []},
      passingProduct: String,
    },
    emits: ['closeForm'],
    setup(props, context) {
      const notificationIsSending = ref(false);
      const store = useStore();

      const notificationForm = reactive({
        notificationGroups: ['all'],
        notifyInProgress: true,
        notifyNew: true,
        passingType: props.type,
        passingProduct: null,
      });

      const sendNotifications = () => {
        notificationIsSending.value = true;

        if (props.passingProduct && props.passingProduct !== 'all') {
          notificationForm.passingProduct = props.passingProduct;
        }

        store.dispatch('group/remindAboutPassings', notificationForm)
            .then(() => {
              message.success('Напоминание направлено');
              setFormClosed();
            }).catch(() => {
              message.error('Произошла ошибка');
            })
            .finally(() => notificationIsSending.value = false);
      };

      const setFormClosed = () => {
        context.emit('closeForm');
      }

      return {
        setFormClosed,
        notificationForm,
        notificationIsSending,
        sendNotifications,
      }
    }
  }
</script>

<style scoped lang="scss">
.notification-button-wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.notification-status-header {
  color: var(--grey-text)
}
</style>